import { cn } from "@auradata/ui";
import { Clock } from "lucide-react";

/** Initials avatar; a clock glyph for automated actors. */
export function Avatar({
  initials,
  name,
  size = 20,
  className,
}: {
  initials: string | null;
  name: string;
  size?: number;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      title={name}
      style={{ width: size, height: size, fontSize: Math.max(9, size * 0.42) }}
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full font-semibold",
        initials ? "bg-surface-inset text-fg-muted" : "bg-surface-subtle text-fg-subtle",
        className,
      )}
    >
      {initials ?? <Clock style={{ width: size * 0.55, height: size * 0.55 }} />}
    </span>
  );
}
